import { Controller } from "@hotwired/stimulus"

// A mapping step's small dropdown "pill" (data_imports): its look follows whether it has a value — the filled or
// empty classes — and choosing a value makes it the merchant's own, so a suggestion's look goes away. Its tooltip is
// the chosen option in full, which a narrow pill may cut off.
export default class extends Controller {
  static targets = ['select']
  static classes = ['filled', 'empty', 'suggested']

  change() {
    const filled = this.selectTarget.value !== ''
    this.selectTarget.title = this.selectTarget.selectedOptions[0]?.text || ''
    this.selectTarget.classList.remove(...this.filledClasses, ...this.emptyClasses, ...this.suggestedClasses)
    this.selectTarget.classList.add(...(filled ? this.filledClasses : this.emptyClasses))
  }
}
